import { required } from 'vuelidate/lib/validators'

export default {
  covenant: {
    covenant_id: {
      required
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/company/covenants/resources/validations.js